import React, { useState } from "react";
import { Button } from "../button/Button";
import { Input } from "../form/input/Input";
export const JumpToPage = ({ currentPage, onPaginationUpdate, recordsPerPage, totalPages, }) => {
    const [page, setPage] = useState(currentPage);
    const [prevCurrentPage, setPrevCurrentPage] = useState(currentPage);
    if (currentPage !== prevCurrentPage) {
        setPrevCurrentPage(currentPage);
        setPage(currentPage);
    }
    const isValid = Number.isInteger(page) && page >= 1 && page <= totalPages;
    const handleSubmit = (event) => {
        if (isValid) {
            onPaginationUpdate(page, recordsPerPage);
        }
        event.preventDefault();
    };
    return (React.createElement("form", { className: "nxm-pagination-page", onSubmit: handleSubmit },
        React.createElement("div", { className: "nxm-pagination-page-label" }, "Page"),
        React.createElement(Input, { "aria-label": "Jump to page", className: "nxm-pagination-page-input", errorMessage: !isValid ? `Enter a page between 1 and ${totalPages}` : undefined, fieldClassName: "w-auto!", hideErrors: true, hideLabel: true, max: totalPages, min: 1, pattern: "[0-9]*", size: "sm", type: "number", value: page, onChange: (e) => {
                if (!Number.isNaN(e.target.valueAsNumber)) {
                    setPage(e.target.valueAsNumber);
                }
            } }),
        React.createElement(Button, { "aria-disabled": !isValid, buttonType: "secondary", filled: "weak", size: "sm", type: "submit" }, "Go")));
};
